<template>
    <div>
        <h5>Discounts</h5>
        <div class="mb-3 mt-3">
            <template v-for="(discount, index) in discounts">
                <div class="form-group input-group">
                    <div class="input-group-prepend" v-if="discount.type.id === discountTypes.FIXED">
                        <div class="input-group-text"><template v-if="sale.websites[0].id === websiteIds.BLINDS_DIRECT_IE">&euro;</template><template v-else>&pound;</template></div>
                    </div>
                    <input type="number" class="form-control" placeholder="Discount" v-model="discount.value" @change="change_array('discount', discount.id)">
                    <div class="input-group-append" v-if="discount.type.id === discountTypes.MULTIPLIER">
                        <div class="input-group-text">%</div>
                    </div>
                    <select class="form-control ml-2" v-model="discount.type.id" @change="change_array('discount', discount.id)">
                        <option v-for="type in types" :value="type.id">{{ type.name }}</option>
                    </select>
                    <div class="input-group-prepend ml-2">
                        <div class="input-group-text">Threshold <template v-if="sale.websites[0].id === websiteIds.BLINDS_DIRECT_IE">&euro;</template><template v-else>&pound;</template></div>
                    </div>
                    <input type="number" class="form-control" placeholder="Threshold" v-model="discount.threshold" @change="change_array('discount', discount.id)">
                    <select class="form-control ml-2" v-model="discount.group.id" @change="change_array('discount', discount.id)">
                        <option :value="null">All Products</option>
                        <option v-for="group in groups" :value="group.id">{{ group.name }}</option>
                    </select>
                    <button class="btn btn-danger ml-2" @click="delete_discount('discount', index, discount.id)"><i class="far fa-trash-alt text-white"></i></button>
                </div>
            </template>
            <button class="btn btn-info mt-2 btn-sm" @click="add_discount()"><i class="fas fa-plus"></i>&nbsp; Add discount</button>
        </div>
        <h5>Delivery Thresholds</h5>
        <div class="mb-3 mt-3">
            <template v-for="(threshold, index) in thresholds">
                <div class="form-group input-group">
                    <div class="input-group-prepend">
                        <div class="input-group-text"><template v-if="sale.websites[0].id === websiteIds.BLINDS_DIRECT_IE">&euro;</template><template v-else>&pound;</template></div>
                    </div>
                    <input type="number" class="form-control" placeholder="Delivery threshold" v-model="threshold.threshold" @change="change_array('threshold', threshold.id)">
                    <select class="form-control ml-2" v-model="threshold.group.id" @change="change_array('threshold', threshold.id)">
                        <option :value="null">All Products</option>
                        <option v-for="group in groups" :value="group.id">{{ group.name }}</option>
                    </select>
                    <button class="btn btn-danger ml-2" @click="delete_discount('threshold', index, threshold.id)"><i class="far fa-trash-alt text-white"></i></button>
                </div>
            </template>
            <button class="btn btn-info mt-2 btn-sm" @click="add_threshold()"><i class="fas fa-plus"></i>&nbsp; Add Delivery Threshold</button>
        </div>
        <h5>Order Total Thresholds</h5>
        <div class="mb-3 mt-3">
            <template v-for="(orderTotalThreshold, index) in order_total_thresholds">
                <div class="form-group input-group">
                    <div class="input-group-prepend" v-if="orderTotalThreshold.discount_type.id === discountTypes.FIXED">
                        <div class="input-group-text"><template v-if="sale.websites[0].id === websiteIds.BLINDS_DIRECT_IE">&euro;</template><template v-else>&pound;</template></div>
                    </div>
                    <input type="number" class="form-control" placeholder="Discount" v-model="orderTotalThreshold.value" @change="change_array('orderTotalThreshold', orderTotalThreshold.id)">
                    <div class="input-group-append" v-if="orderTotalThreshold.discount_type.id === discountTypes.MULTIPLIER">
                        <div class="input-group-text">%</div>
                    </div>
                    <select class="form-control ml-2" v-model="orderTotalThreshold.discount_type.id" @change="change_array('orderTotalThreshold', orderTotalThreshold.id)">
                        <option v-for="type in types" :key="type.id" :value="type.id">{{ type.name }}</option>
                    </select>
                    <div class="input-group-prepend ml-2">
                        <div class="input-group-text">Threshold <template v-if="sale.websites[0].id === websiteIds.BLINDS_DIRECT_IE">&euro;</template><template v-else>&pound;</template></div>
                    </div>
                    <input type="number" class="form-control" placeholder="Threshold" v-model="orderTotalThreshold.threshold" @change="change_array('orderTotalThreshold', orderTotalThreshold.id)">
                    <button class="btn btn-danger ml-2" @click="delete_discount('orderTotalThreshold', index, orderTotalThreshold.id)"><i class="far fa-trash-alt text-white"></i></button>
                </div>
            </template>
            <button class="btn btn-info mt-2 btn-sm" @click="add_order_total_threshold()"><i class="fas fa-plus"></i>&nbsp; Add Order Total Threshold</button>
        </div>
        <div>
            <button class="btn btn-danger mr-1" @click="closeSection"><i class="far fa-times-circle"></i>&nbsp; Close</button>
            <button class="btn btn-primary mr-1" @click="save()"><i class="far fa-save"></i>&nbsp; Save</button>
            <button class="btn btn-success" @click="save('close')"><i class="fas fa-save"></i>&nbsp; Save &amp; close</button>
        </div>
        <loader :loading="loading"></loader>
    </div>
</template>

<script>

import loader from './loader.vue';
import {websiteIds} from "../enum/websites";
import {discountTypes} from "../enum/discountTypes";

export default {
    computed: {
        discountTypes() {
            return discountTypes
        },
        websiteIds() {
            return websiteIds
        }
    },

    components: {
        loader
    },

    data() {
        return {
            discounts: {},
            thresholds: {},
            order_total_thresholds: {},
            groups: {},
            types: {},
            discount_changed: [],
            threshold_changed: [],
            order_total_threshold_changed: [],
            deleted_discounts: [],
            deleted_thresholds: [],
            deleted_order_total_thresholds: [],
            axios_array: [],

            loading: true,
            load_count: 0,
        };
    },

    props: {
        sale: Object,
    },

    mounted(){
        this.discounts = this.sale.discounts;
        this.thresholds = this.sale.delivery_thresholds;
        this.order_total_thresholds = this.sale.order_total_thresholds;
        this.get_groups_types();
        this.update_discounts();

        history.pushState({page: 0}, "", window.location.pathname + "?page=discounts");
    },

    methods: {
        save(close) {
            let group;
            this.loading_count();
            if(this.load_count > 0){
                this.loading = true;
            } else if(close){
                this.closeSection();
            }
            if(this.deleted_discounts.length > 0){
                for(let del in this.deleted_discounts){
                    this.axios_array.push(axios.delete('/sales/' + this.sale.id + '/discounts/' + this.deleted_discounts[del]))
                }
            }
            if(this.deleted_thresholds.length > 0){
                for(let del in this.deleted_thresholds){
                    this.axios_array.push(axios.delete('/sales/' + this.sale.id + '/delivery-thresholds/' + this.deleted_thresholds[del]))
                }
            }
            if(this.deleted_order_total_thresholds.length > 0){
                for(let del in this.deleted_order_total_thresholds){
                    this.axios_array.push(axios.delete('/sales/' + this.sale.id + '/order-total-thresholds/' + this.deleted_order_total_thresholds[del]))
                }
            }

            // Create or update discounts
            for(let discount in this.discounts){
                group = null;
                if(this.discounts[discount].group.id != null){
                    group = this.discounts[discount].group.id;
                }
                let discount_value = this.discounts[discount].value;
                if(this.discounts[discount].type.id === discountTypes.MULTIPLIER){
                    discount_value = this.to_value(this.discounts[discount].value)
                }
                if(this.discount_changed.includes(this.discounts[discount].id) && this.discounts[discount].id){
                    this.axios_array.push(axios.patch('/sales/' + this.sale.id + '/discounts/' + this.discounts[discount].id,{
                        group_id: group,
                        value: discount_value,
                        threshold: this.discounts[discount].threshold,
                        discount_type_id: this.discounts[discount].type.id,
                    }))
                } else if(!this.discounts[discount].id){
                    this.axios_array.push(axios.post('/sales/' + this.sale.id + '/discounts',
                    {
                        group_id: group,
                        value: discount_value,
                        threshold: this.discounts[discount].threshold,
                        discount_type_id: this.discounts[discount].type.id,
                    }))
                }
            }

            // Create or update delivery thresholds
            for(let threshold in this.thresholds){
                group = null;
                if(this.thresholds[threshold].group.id != null){
                    group = this.thresholds[threshold].group.id;
                }
                if(this.threshold_changed.includes(this.thresholds[threshold].id) && this.thresholds[threshold].id){
                    this.axios_array.push(axios.patch('/sales/' + this.sale.id + '/delivery-thresholds/' + this.thresholds[threshold].id,{
                        group_id: group,
                        threshold: this.thresholds[threshold].threshold,
                    }))
                } else if(!this.thresholds[threshold].id){
                    this.axios_array.push(axios.post('/sales/' + this.sale.id + '/delivery-thresholds',
                    {
                        group_id: group,
                        threshold: this.thresholds[threshold].threshold,
                    }))
                }
            }

            // Create or update order total thresholds
            for ( let orderTotalThreshold in this.order_total_thresholds ) {

                // Convert the percentage value based on the discount type
                let order_total_threshold_value = this.order_total_thresholds[orderTotalThreshold].value;
                if(this.order_total_thresholds[orderTotalThreshold].discount_type.id === discountTypes.MULTIPLIER){
                    order_total_threshold_value = this.to_value(this.order_total_thresholds[orderTotalThreshold].value)
                }

                if(this.order_total_threshold_changed.includes(this.order_total_thresholds[orderTotalThreshold].id) && this.order_total_thresholds[orderTotalThreshold].id){

                    // Changed means they should be updated, so call the "update" method and add it to the "update" queue
                    this.axios_array.push(axios.patch('/sales/' + this.sale.id + '/order-total-thresholds/' + this.order_total_thresholds[orderTotalThreshold].id,{
                        threshold: this.order_total_thresholds[orderTotalThreshold].threshold,
                        discount_type_id: this.order_total_thresholds[orderTotalThreshold].discount_type.id,
                        value: order_total_threshold_value,
                    }));

                } else if(!this.order_total_thresholds[orderTotalThreshold].id){

                    // If the state model data doesn't have id, it must be brand new, therefore add it to the "create" queue
                    this.axios_array.push(axios.post('/sales/' + this.sale.id + '/order-total-thresholds', {
                        threshold: this.order_total_thresholds[orderTotalThreshold].threshold,
                        discount_type_id: this.order_total_thresholds[orderTotalThreshold].discount_type.id,
                        value: order_total_threshold_value,
                    }));

                }
            }

            axios.all(this.axios_array)
                .then(function (responses){
                        if(responses.length > 0){
                            // Reload
                            axios.get('/sales/' + this.sale.id)
                            .then(function (response) {
                                this.discounts = response.data.sale.discounts;
                                this.thresholds = response.data.sale.delivery_thresholds;
                                this.order_total_thresholds = response.data.sale.order_total_thresholds;
                                this.check_load(close);
                                this.update_discounts();
                            }.bind(this)) // bound scope
                            .catch(function (error) {
                                alert(error);
                                this.check_load(close);
                                this.update_discounts();
                                window.location.reload(); // This is currently unrecoverable, so reload the page.
                            }.bind(this)) // bound scope
                        }
                    }.bind(this) // bound reference
                )
                .catch((reason) => {alert(reason.toString());})
                .finally(() => {
                    if ( !close ) {
                        window.location.reload(); // Sale is a prop passed in from blade view as json object
                    }
                });
        },
        add_discount(){
            this.discounts.push(
                {
                    group: {id: null},
                    threshold: 0,
                    type: {
                        id: 1,
                        name: 'Multiplier'
                    },
                    value: 0,
                }
            );
        },
        add_threshold(){
            this.thresholds.push(
                {
                    group: {id: null},
                    threshold: 0,
                }
            );
        },
        add_order_total_threshold(){
            this.order_total_thresholds.push(
                {
                    threshold: 0,
                    value: 0,
                    discount_type: {
                        id: 1,
                    },
                }
            );
        },
        delete_discount(type, index, id){
            if(type === 'discount'){
                if(id){
                    this.deleted_discounts.push(id);
                }
                this.discounts.splice(index, 1);
            } else if (type === 'orderTotalThreshold') {
                if (id) {
                    this.deleted_order_total_thresholds.push(id);
                }
                this.order_total_thresholds.splice(index, 1);
            } else {
                if(id){
                    this.deleted_thresholds.push(id);
                }
                this.thresholds.splice(index, 1);
            }
        },
        update_discounts() {
            // Update discounts
            for(let discount in this.discounts){
                if(this.discounts[discount].type.id === discountTypes.MULTIPLIER){
                    this.discounts[discount].value = this.to_percent(this.discounts[discount].value);
                }
                if(this.discounts[discount].group == null){
                    Vue.set( this.discounts[discount], 'group', {'id':null});
                }
            }
            // Update delivery thresholds
            for(let threshold in this.thresholds){
                if(this.thresholds[threshold].group == null){
                    Vue.set( this.thresholds[threshold], 'group', {'id':null});
                }
            }
            // Update order total thresholds
            for ( let orderTotalThreshold in this.order_total_thresholds ) {
                if ( this.order_total_thresholds[orderTotalThreshold].discount_type.id === discountTypes.MULTIPLIER ) {
                    this.order_total_thresholds[orderTotalThreshold].value = this.to_percent(this.order_total_thresholds[orderTotalThreshold].value);
                }
            }
        },
        get_groups_types(){
            let get_requests = 0;
            axios.get('/groups/list')
            .then(function (response) {
                get_requests++
                if(get_requests === 2){
                    this.loading = false;
                    get_requests = 0
                }
                this.groups = response.data.groups;
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error);
            })
            axios.get('/discount-types/list')
            .then(function (response) {
                get_requests++
                if(get_requests === 2){
                    this.loading = false;
                    get_requests = 0
                }
                this.types = response.data.discount_types;
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error);
            })
        },
        change_array(type, id){
            if(id){
                if(type === 'discount'){
                    if(!this.discount_changed.includes(id)){
                        this.discount_changed.push(id);
                    }
                } else if (type === 'orderTotalThreshold') {
                    if (!this.order_total_threshold_changed.includes(id)) {
                        this.order_total_threshold_changed.push(id);
                    }
                } else {
                    if(!this.threshold_changed.includes(id)){
                        this.threshold_changed.push(id);
                    }
                }
            }
        },
        to_percent(value){
            return 100 - (value * 100);
        },
        to_value(value){
            return parseFloat((1 - (value / 100)).toFixed(2));
        },
        loading_count(){
            let loadCount =
                this.discount_changed.length + this.deleted_discounts.length +
                this.threshold_changed.length + this.deleted_thresholds.length +
                this.order_total_threshold_changed.length + this.deleted_order_total_thresholds.length;

            for(let discount in this.discounts){
                if(!this.discounts[discount].id){
                    loadCount++;
                }
            }
            for(let threshold in this.thresholds){
                if(!this.thresholds[threshold].id){
                    loadCount++;
                }
            }
            for (let orderTotalThreshold in this.order_total_thresholds) {
                if ( !this.order_total_thresholds[orderTotalThreshold].id ) {
                    loadCount++;
                }
            }
            this.load_count = loadCount;
        },
        check_load(close){
            this.changed = [];
            this.deleted = [];
            this.axios_array = [];
            this.loading = false;
            if(close === 'close'){
                this.closeSection();
            }
        },
        closeSection (event) {
            history.pushState({page: 0}, "", window.location.pathname);
            this.$emit('closeChild', false);
        },
    },
};
</script>
